// extracted by mini-css-extract-plugin
module.exports = {"title":"EditableTitle_title__tjQ7H","titleInput":"EditableTitle_titleInput__gBfs_"};